import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

/**
 * Centralised axios instance.
 *
 * Authentication strategy:
 *  - The backend sets an httpOnly, Secure, SameSite=None cookie named
 *    `session_token`. Browsers send it automatically with `withCredentials: true`.
 *  - We deliberately DO NOT persist tokens in localStorage to avoid XSS exfiltration.
 */
export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

/**
 * Log API errors centrally. Network/4xx/5xx errors propagate to callers, but we
 * always surface them in the console for debuggability.
 */
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response) {
            // Server responded with an error status
            const status = error.response.status;
            // 401 is expected for unauthenticated pages; quieter logging
            const logger = status === 401 ? console.info : console.warn;
            logger(`[api] ${error.config?.method?.toUpperCase?.()} ${error.config?.url} -> ${status}`, error.response.data);
        } else if (error?.request) {
            console.warn("[api] No response received", error.message);
        } else {
            console.warn("[api] Request setup error", error.message);
        }
        return Promise.reject(error);
    }
);
